import { useState, useEffect, ComponentType } from 'react';
import LoadingSpinner from './LoadingSpinner';

interface LazyComponentOptions {
  fallback?: ComponentType<any>;
}

// Creates a lazy-loaded component that works with SSR
const createLazyComponent = <T extends ComponentType<unknown> = ComponentType<unknown>>(
  importFunc: () => Promise<{ default: T }>,
  options: LazyComponentOptions = {}
) => {
  const { fallback: Fallback = LoadingSpinner } = options;

  return (props: any) => {
    const [Component, setComponent] = useState<T | null>(null);

    useEffect(() => {
      // Only load on client-side after component mounts
      const loadComponent = async () => {
        try {
          const module = await importFunc();
          setComponent(() => module.default);
        }
        // eslint-disable-next-line no-unused-vars
        catch (error) {}
      };

      loadComponent();
    }, []);

    if (!Component) {
      return <Fallback />;
    }

    return <Component { ...props } />;
  };
};

export default createLazyComponent;
